const smtPqSectionTitle = {
    // Brand-coloured text, so the contrast-checked text token. The old dark
    // half, brand.600, was 2.4:1 on the dark sections.
    color: {
        default: 'shared.text.brand',
    },
};

export default smtPqSectionTitle;